import { AppointmentCard } from "./appointment-card";

export const AppointmentList = ({ appointments }) => {
    return (
        <div className="space-y-4">
            {appointments.map((appointment) => {
                return (
                    <AppointmentCard
                        key={appointment.appointmentGuid}
                        appointment={appointment}
                    />
                );
            })}
        </div>
    );
};
